import React from 'react';

type PlusIconProps = {
  className?: string;
};

/**
 * «+» con trazo grueso y puntas redondeadas, para el menú de las pills
 * (fila «Vincular recorrido a la OT»). El `add-icon.svg` de las barras de
 * filtros es de línea fina: a 1.1rem se quedaba en menos de 1 px y no
 * casaba con el ojo, el lápiz y la ✕ de las otras filas (revisión del
 * usuario 28/09). El color lo pone quien lo usa (`path { stroke }`).
 */
export const PlusIcon = ({ className }: PlusIconProps): JSX.Element => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5 1.2V8.8M1.2 5H8.8"
      stroke="#757575"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
